import { NominationSummary } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNominationSummaries: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<NominationSummary[]> = (fetchContext, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nomination-summaries`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationSummary[]>(fetchContext.errorStore, response, 'get nomination summaries'));
